import { useState, useEffect } from "react";
import { getSurveyResultsByOrg } from "../../dataApi/organizations";
export const useSurveyData = (listId: string) => {
  const [surveyResults, setSurveyResults] = useState<any[]>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const surveys = await getSurveyResultsByOrg(listId);
      if (surveys) {
        setSurveyResults(surveys);
      }
      setLoading(false);
    })();
  }, []);

  return { surveyResults, loading };
};
